import { useState } from "react";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import {
  CreationForm,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import DragDropInput from "../../components/form/DragDropInput";
import DataTable from "../../components/dataTables/DataTable";
import { AddPodcastFormTemplate } from "../../data-parsing/podcasts/AddPodcastFormTemplate";
import { Podcast } from "../../data-parsing/podcasts/Podcast";
import { useMedia, usePodcast, usePodcasts } from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { fileToDataURL } from "../../data-parsing/parseUtils";

export function Podcasts() {
  const [query, setQuery] = useState(null);
  const { podcasts, createPodcast, deletePodcast } = usePodcasts(query);
  const { updatePodcast } = usePodcast();
  const colDefs = buildColDefs(Podcast);
  const { createMedia } = useMedia("food/podcasts/", "");

  const afterSubmit = (newElement, parsedFormData) => {
    console.log("parsedFormData");
    console.log(parsedFormData);
    fileToDataURL(
      newElement?._id,
      parsedFormData[0][`podcast`],
      "",
      createMedia,
      false,
      "Video"
    );
    if (parsedFormData[0][`thumbnail`] && parsedFormData[0][`thumbnail`].size) {
      fileToDataURL(
        newElement?._id,
        parsedFormData[0][`thumbnail`],
        "",
        createMedia,
        true,
        "Image"
      );
    }
  };

  return (
    <LeftSideMenu active="podcasts">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="card-box card-tabs m-t-20">
              <h4 className="header-title m-t-0 m-b-30 pull-right">PÓDCASTS</h4>
              <TabbedContent
                tabHeaders={[
                  <button data-toggle="tab" aria-expanded="true">
                    <i className="fas fa-plus-circle"></i> NUEVO PÓDCAST
                  </button>,
                  <button
                    data-toggle="tab"
                    aria-expanded="false"
                    onClick={() => setQuery(0)}
                  >
                    <i className="far fa-eye"></i> LISTAR PÓDCASTS
                  </button>,
                ]}
              >
                <div className="fade in ">
                  <div className="row">
                    <CreationForm
                      createFunction={createPodcast}
                      afterSubmit={afterSubmit}
                    >
                      <div className="col-md-5">
                        <div className="form-group">
                          <label>Imagen</label>
                          <DragDropInput
                            fileTypes={["JPG", "PNG", "GIF"]}
                            name={"thumbnail"}
                            style={{ height: "300px" }}
                          />
                        </div>

                        <div className="form-group">
                          <label>Pódcast</label>
                          <DragDropInput
                            fileTypes={["MP4", "WEBM"]}
                            name={"podcast"}
                            style={{ height: "300px" }}
                            required={true}
                          />
                        </div>
                      </div>
                      <CreationFormTemplate
                        formTemplate={AddPodcastFormTemplate}
                        dataTemplate={Podcast}
                      />

                      <div className="col-sm-12">
                        <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                          <i className="far fa-save"></i> Guardar Pódcast
                        </button>
                      </div>
                    </CreationForm>
                  </div>
                </div>

                <div className="fade in">
                  <DataTable
                    data={podcasts}
                    colDefs={colDefs}
                    dataId={"Podcasts"}
                    scrollX={false}
                    allowHiddenColumns={true}
                    dataTemplate={Podcast}
                    resizable={true}
                    className="table table-bordered panel-group"
                    editElement={updatePodcast}
                    deleteElement={deletePodcast}
                  />
                </div>
              </TabbedContent>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
export default Podcasts;
